import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../api';
import { toast } from 'react-toastify';

export default function ResetPassword() {
  const query = new URLSearchParams(useLocation().search);
  const email = query.get("email");
  const token = query.get("token"); // récupère le token de l'URL
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const navigate = useNavigate();

  const handleReset = () => {
    if (password !== passwordConfirm) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }

    api.post('/reset-password', {
      email,
      token,            
      new_password: password,
      new_password_confirmation: passwordConfirm // si Laravel validate "confirmed"
    })
    .then(res => {
      toast.success(res.data.message || "Mot de passe réinitialisé !");
      navigate("/login");
    })
    .catch(err => {
      const msg = err.response?.data?.message || "Erreur lors de la réinitialisation";
      toast.error(msg);
    });
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white shadow rounded-lg mt-10">
      <h1 className="text-xl font-bold mb-4">Réinitialisation du mot de passe</h1>
      <input
        type="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        placeholder="Nouveau mot de passe"
        className="w-full border px-3 py-2 rounded mb-4"
      />
      <input
        type="password"
        value={passwordConfirm}
        onChange={e => setPasswordConfirm(e.target.value)}
        placeholder="Confirmer le mot de passe"
        className="w-full border px-3 py-2 rounded mb-4"
      />
      <button onClick={handleReset} className="w-full bg-blue-600 text-white py-2 rounded">
        Réinitialiser
      </button>
    </div>
  );
}
